import { Viewer, utils } from "@photo-sphere-viewer/core";
import { MarkersPlugin } from "@photo-sphere-viewer/markers-plugin";
import { GalleryPlugin } from "@photo-sphere-viewer/gallery-plugin";
import { AutorotatePlugin } from "@photo-sphere-viewer/autorotate-plugin";
import { GyroscopePlugin } from "@photo-sphere-viewer/gyroscope-plugin";
import "@photo-sphere-viewer/core/index.css";
import "@photo-sphere-viewer/markers-plugin/index.css";
import "@photo-sphere-viewer/gallery-plugin/index.css";
export default {
  props: {
    hasAnimate: {
      type: Boolean,
      default: true
    },
    imgList: [],
    hasGallery: {
      type: Boolean,
      default: true
    }
  },
  components: {},
  data() {
    return {
      viewer: "",
      panoramaUrl: "",
      markersPlugin: "",
      autorotatePlugin: "",
      galleryPlugin: "",
      gyroscopePlugin: "",
      currIndex: 0,
      animatedValues: {
        // pitch: { start: -Math.PI / 2, end: -0.5 },
        pitch: {
          start: -Math.PI / 2,
          end: -0.5
        },
        // yaw: { start: Math.PI, end: 0 },
        yaw: {
          start: -Math.PI,
          end: 0
        },
        zoom: {
          start: 0,
          end: 50
        },
        fisheye: {
          start: 2,
          end: 0
        }
      },
      defaultUrl: require("../assets/sphere.jpg")
    };
  },
  created() {},
  mounted() {
    this.panoramaUrl = this.imgList[0].panorama || this.defaultUrl;
    this.initViewer();
    // this.enteraAimation();
    this.handelListenerViewerClick();
    this.handleSelectMarker();
    this.handleHoverMarker();
    this.handleLeaveMarker();
    this.$nextTick(() => {
      this.handleGalleryChange();
    });
  },
  watch: {},
  methods: {
    initViewer() {
      const _this = this;
      this.viewer = new Viewer({
        container: "viewer",
        panorama: this.panoramaUrl || this.defaultUrl,
        caption: "北国之春",
        loadingImg: require("../assets/logo.png"),
        touchmoveTwoFingers: false,
        mousewheelCtrlKey: false,
        navbar: ["autorotate", "zoom", "markers", "move",
        // "download",
        "gallery",
        // {
        //   title: "Change points",
        //   content: "🔄",
        //   onClick: _this.randomPoints,
        // },
        // "caption",
        "fullscreen"],
        plugins: [[GalleryPlugin, {
          visibleOnLoad: true,
          hideOnClick: false
        }], [GyroscopePlugin, {
          touchmove: true,
          absolutePosition: true,
          moveMode: "smooth"
        }], [AutorotatePlugin, {
          autostartDelay: null,
          autorotatePitch: _this.animatedValues.pitch.end,
          autostartOnIdle: false,
          autorotateSpeed: "1rpm"
        }], [MarkersPlugin, {
          markers: []
        }]]
      });
      _this.markersPlugin = _this.viewer.getPlugin(MarkersPlugin);
      _this.autorotatePlugin = _this.viewer.getPlugin(AutorotatePlugin);
      _this.galleryPlugin = _this.viewer.getPlugin(GalleryPlugin);
      if (_this.hasGallery) {
        _this.galleryPlugin.setItems(_this.imgList); //设置图库
      }

      _this.viewer.addEventListener("ready", _this.handleViewerReady, {
        once: true
      });
    },
    //入场动画
    enteraAimation() {
      const _this = this;
      _this.autorotatePlugin.stop();
      new utils.Animation({
        properties: _this.animatedValues,
        duration: 5500,
        easing: "inOutQuad",
        onTick: properties => {
          _this.viewer.setOption("fisheye", properties.fisheye);
          _this.viewer.rotate({
            yaw: properties.yaw,
            pitch: properties.pitch
          });
          _this.viewer.zoom(properties.zoom);
        }
      }).then(() => {
        if (this.hasGallery) {
          this.galleryPlugin.setItems(this.imgList); //设置图库
        }

        _this.autorotatePlugin.start();
      });
    },
    handleViewerReady() {
      this.markersPlugin.setMarkers(this.imgList[this.currIndex].markers); //设置标签
      this.showInitMarker();
      this.enteraAimation();
    },
    showInitMarker() {
      const _this = this;
      this.viewer.animate({
        yaw: "-27deg",
        pitch: "-6deg",
        speed: 100
      }).then(() => {
        _this.markersPlugin.showMarkerTooltip("new-marker1");
        // _this.markersPlugin.showMarkerTooltip("new-marker3");
        _this.markersPlugin.showMarkerTooltip("marker_weather");
        _this.markersPlugin.showMarkerTooltip("bowuguanNeijing");
        _this.markersPlugin.showMarkerTooltip("huahaiNeijing");
        // _this.autorotatePlugin.start();
      });
    },

    //清除标记
    clearMarker() {
      this.markersPlugin.clearMarkers();
    },
    //更新标记
    updateMarker(id, imgUrl) {
      this.markersPlugin.updateMarker({
        id: id,
        image: imgUrl
      });
    },
    updateIndex(index) {
      console.log(index);
      // if(index==1){
      //   this.animatedValues.pitch.end = 0.5 ;
      //   console.log(this.animatedValues.pitch.end)
      // }
      this.currIndex = index;
      this.panoramaUrl = this.imgList[index].panorama;
      this.handelChangeViewer("gallery");
    },
    //选择标记事件
    handleSelectMarker() {
      const _this = this;
      this.markersPlugin.addEventListener("select-marker", ({
        marker
      }) => {
        this.$emit("selectMarker", marker);
      });
    },
    //标记悬停事件
    handleHoverMarker() {
      this.markersPlugin.addEventListener("enter-marker", ({
        marker
      }) => {
        /*  console.log("enter"); */
      });
    },
    handleLeaveMarker() {
      this.markersPlugin.addEventListener("leave-marker", ({
        marker
      }) => {
        /* console.log("leave"); */
      });
    },
    //gallery图库列表切换
    handleGalleryChange() {
      const _this = this;
      let _sindex = "";
      document.addEventListener("click", function (e) {
        var element = document.elementFromPoint(e.clientX, e.clientY);
        let flag = false;
        if (element && element.dataset && element.dataset.psvGalleryItem) {
          const id = element.dataset.psvGalleryItem;
          _sindex = _this.imgList.findIndex(data => {
            return data.id == id;
          });
          flag = true;
        } else {
          if (element && element.className == "psv-gallery-item-thumb") {
            const eleId = element.parentElement.parentElement.dataset.psvGalleryItem;
            _sindex = _this.imgList.findIndex(data => {
              return data.id == eleId;
            });
            flag = true;
          }
        }
        if (flag) {
          if (_this.currIndex == _sindex) {
            console.log("点击了未切换");
          } else {
            _this.currIndex = _sindex;
            _this.panoramaUrl = _this.imgList[_sindex].panorama;
            _this.handelChangeViewer("gallery");
          }
        }
      });
    },
    //图库列表当前选中active更新
    handelGalleryActive() {
      const galleryBox = document.getElementsByClassName("psv-gallery-container")[0];
      const galleryItemEle = document.getElementsByClassName("psv-gallery-item")[this.currIndex];
      galleryBox.childNodes.forEach(item => {
        item.className = "psv-gallery-item";
      });
      galleryItemEle.classList.add("psv-gallery-item--active");
    },
    /***
     * viewer 切换场景
     * */

    handelChangeViewer(type) {
      const _this = this;
      if (_this.viewer) {
        _this.clearMarker();
        _this.handelGalleryActive();
        _this.viewer.setPanorama(_this.panoramaUrl).then(() => {
          _this.markersPlugin.setMarkers(_this.imgList[_this.currIndex].markers);
          if (_this.currIndex == 0) {
            this.markersPlugin.showMarkerTooltip("new-marker1");
            // this.markersPlugin.showMarkerTooltip("new-marker3");
            this.markersPlugin.showMarkerTooltip("marker_weather");
          } else if (_this.currIndex == 1) {
            this.markersPlugin.showMarkerTooltip("new-marker21");
          }
        });
        if (type != "gallery") {
          this.handelGalleryActive();
        }
      }
    },
    //viewer点击事件监听
    handelListenerViewerClick(addMarker) {
      const _this = this;
      const emptyMarker = {
        image: require("./../assets/logo.png"),
        width: 32,
        height: 32
      };
      addMarker = addMarker ? addMarker : emptyMarker;
      this.viewer.addEventListener("click", ({
        data
      }) => {
        console.log("view 被点击");
        console.log("yaw:" + data.yaw.toFixed(3) + " ,pitch: " + data.pitch.toFixed(3));
        console.log(data.yaw.toFixed(3) + " ," + data.pitch.toFixed(3));
        if (!data.rightclick) {
          _this.$emit("viewerClick", data);
          _this.markersPlugin.addMarker({
            id: "#" + Math.random(),
            position: {
              yaw: data.yaw,
              pitch: data.pitch
            },
            image: addMarker.image || require("./../assets/logo.png"),
            size: {
              width: addMarker.width || 32,
              height: addMarker.height || 32
            },
            anchor: "bottom center",
            tooltip: addMarker.tooltip || "新增标记",
            data: {
              generated: true
            }
          });
        }
      });
    },
    randomPoints() {
      /*  this.markersPlugin.showMarkerTooltip("new-marker3"); */
      this.markersPlugin.showAllTooltips();
    }
  }
};